import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../services/axois";
import { formatDateToUTC } from "../../../utility/genricFunction";
// this is for demo purpose only / change for further api calls


export const getStudentExam = createAsyncThunk(
  "studentExam/studentResult",
  async ({studentId}) => {
    try {
      let url = `/student/exam-result/${studentId}`;
      const response = await apiClient.get(url);
      response?.data?.result?.forEach(student => {
        const date = new Date(student.date);
        student.date = formatDateToUTC(date)
      });   
      return response?.data?.result; // todo: need to store only "result" array inside redux state
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);




